import { numericUtil } from '@cmg/common';
import { createValueFormatter } from '@cmg/data-grid';

import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';

export type Value = NonNullable<
  CalendarGridRowData['attributes']
>['latestPremiumTalkLowPercentage'];

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => numericUtil.getDisplayValueForPercents(value, 3),
});

const premiumTalkLowColDef: CalendarGridColDef<Value> = {
  field: 'attributes.latestPremiumTalkLowPercentage',
  headerName: 'Premium Talk Percentage Low',
  width: 150,
  valueFormatter,
};

export default premiumTalkLowColDef;
